export default "/img/BB.f019db0b0ff17a9d6e49b599061f0722.png";